const Username: React.FC<{
  username: string;
  userId: string;
  petId: string;
}> = (props) => {
  const handelClick = () => {
    window.open(`/app/customer/profile/customer-details/appointments/${props?.userId}/${props?.petId}`);
  };
  return (
    <>
      <p className="text-blue-500 text-xs cursor-pointer" onClick={() => handelClick()}>
        {props?.username}
      </p>
    </>
  );
};

export default Username;
